import { render, staticRenderFns } from "./tanuki_bot_chat_message.vue?vue&type=template&id=7f197839&"
import script from "./tanuki_bot_chat_message.vue?vue&type=script&lang=js&"
export * from "./tanuki_bot_chat_message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports